module.exports = __webpack_public_path__ + "static/media/Dangerous.fc1b57ba.png";